import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import RestaurantPortfolio from "./pages/RestaurantPortfolio";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RestaurantPortfolio />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
